import { useState } from "react";
import { MessageCircle } from "lucide-react";
import CommentModal from "./CommentModal";

const COMMENT_COLOR = 'oklch(54.6% 0.245 262.881)';

export default function CommentSection({ postId, commentCount = 0 }) {
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(false);

  const active = open || hovered;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="flex items-center gap-1.5 p-2 rounded-full
          transition-all duration-200 hover:scale-110 active:scale-95"
      >
        <MessageCircle
          className="w-6 h-6 transition-all duration-200"
          style={{
            color: active ? COMMENT_COLOR : 'rgb(243,244,246)',
            fill: open ? COMMENT_COLOR : 'transparent',
            filter: open ? `drop-shadow(0 0 6px ${COMMENT_COLOR})` : 'none',
          }}
        />
        {commentCount > 0 && (
          <span
            className="text-sm font-medium transition-colors duration-200"
            style={{ color: active ? COMMENT_COLOR : 'rgb(209,213,219)' }}
          >
            {commentCount}
          </span>
        )}
      </button>

      <CommentModal
        isOpen={open}
        onClose={() => setOpen(false)}
        postId={postId}
      />
    </>
  );
}
